import { render, staticRenderFns } from "./shelf-edit.vue?vue&type=template&id=064069b1&scoped=true&"
import script from "./shelf-edit.vue?vue&type=script&lang=ts&"
export * from "./shelf-edit.vue?vue&type=script&lang=ts&"
import style0 from "./shelf-edit.vue?vue&type=style&index=0&id=064069b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064069b1",
  null
  
)

export default component.exports